import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from "@angular/core";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AcompanhamentoProcessualOperacao } from "src/app/model/acompanhamento-processual.model";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { STATUS_PROTOCOLO } from "src/app/model/protocolo-arquivo.model";
import Utils from "src/app/shared/fgi-utils";

@Component({
    selector: 'acompanhamento-processual-listagem',
    templateUrl: 'acompanhamento-processual-listagem.component.html',
    styleUrls: ['acompanhamento-processual-listagem.component.scss'],
    standalone: false
})
export class AcompanhamentoProcessualListagemComponent {
    @Input() agentesFinanceiros: AgenteFinanceiro[];
    @Input() acompanhamentosOperacao: AcompanhamentoProcessualOperacao[];
    @Input() atributosPaginacao: EntityPagedRequestParameters;
    @Input() ehAgenteFinanceiro: boolean;
    
    @Output() aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
    @Output() aoRequererDesativacao: EventEmitter<AcompanhamentoProcessualOperacao> = new EventEmitter<AcompanhamentoProcessualOperacao>();
    private atributosOrdenacao: EntityOrderedRequestParameters;
    public opcoesPaginacao: number[] =[10,15,20];
    
    nomeAgenteFinanceiro(cnpj: string) {
        return Utils.nomeAgentePorCNPJ(cnpj, this.agentesFinanceiros);
    }

    descricaoStatusProtocolo(codigo) {
        return STATUS_PROTOCOLO.filter(s => s.codigo == codigo)[0]?.label || 'Status não encontrado';
    }

    mudancaPagina(novaPagina: EntityPagedRequestParameters) {
        this.atributosPaginacao = novaPagina;
        this.aoMudarPagina.emit(novaPagina);
    }

    mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
        this.atributosOrdenacao = novaOrdenacao;
        this.pesquisarOrdenacao(this.atributosOrdenacao);
    }

    nomeStatusProtocolo(codigo: string) {
        for (let status of STATUS_PROTOCOLO) {
            if (status.codigo == codigo) {
                return status.label;
            }
        }
    }

    pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
        this.acompanhamentosOperacao = this.acompanhamentosOperacao.sort((a, b) => {
            if (ord.sentido == "asc") {
                return Utils.compara(a, b, ord.atributo);
            }
            else {
                return -1 * Utils.compara(a, b, ord.atributo);
            }
        });
    }
}